import { type GridVersion } from 'honeygrid-types'
import { Home } from 'lucide-react'

import type { FC } from 'react'

interface TargetingCoverageMetricRowProps {
	grid_version?: GridVersion
}

export const TargetingCoverageMetricRow: FC<TargetingCoverageMetricRowProps> = ({
	grid_version,
}) => {
	if (!grid_version) return null

	const targetedHouseholds = grid_version.targeted_households ?? 0
	const totalHouseholds = grid_version.households ?? 0
	const percentage = totalHouseholds > 0 ? targetedHouseholds / totalHouseholds : 0

	return (
		<div className="flex items-center gap-2">
			<Home className="h-4 w-4" />
			<p className="text-sm">
				{`${targetedHouseholds.toLocaleString('en-US', {
					notation: 'compact',
					compactDisplay: 'short',
				})}/${totalHouseholds.toLocaleString('en-US', {
					notation: 'compact',
					compactDisplay: 'short',
				})}`}{' '}
				population (
				{percentage.toLocaleString('en-US', {
					style: 'percent',
					maximumFractionDigits: 1,
				})}
				)
			</p>
		</div>
	)
}
